import DocViewShell from "@/components/DocViewShell";
import VrioBlueprint from "@/components/blueprints/VrioBlueprint";

export default function VrioView() {
  return (
    <DocViewShell
      eyebrow="VRIO Capability Assessment"
      eyebrowClass="text-indigo-700"
      toolName="VRIO Capability Assessment"
      maxWidth="max-w-3xl"
      editPathFn={(id) => `/vrio/${id}`}
      render={(doc) => <VrioBlueprint doc={doc} />}
    />
  );
}
